export const problems = [
  {
    title: 'You found drills, not a unit',
    text: 'A video here, a worksheet there. None of it connects into twelve lessons that build on each other.',
  },
  {
    title: 'The class waits while you set up',
    text: 'You’re placing cones and explaining the layout while thirty children stand around losing focus.',
  },
  {
    title: 'Big groups, long lines',
    text: 'One activity, one ball, one queue. Most of the class spends the lesson watching instead of playing.',
  },
  {
    title: 'Mixed levels in the same lesson',
    text: 'Some pupils have barely caught a ball. Others want a real game. One plan has to work for both.',
  },
  {
    title: 'Not sure what comes next',
    text: 'After passing and catching, should you teach shooting, space or games? The order feels like guesswork.',
  },
  {
    title: 'Handball is new to you',
    text: 'You know how to run a PE class, but not the cues, progressions and small games that make handball click.',
  },
];
